var _module_exports = "{{ ::$ctrl.message }}\n";;
var path = '/workspace/src/app/common/ui/form/validation-message/validation-message.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;